(function(){
'use strict';

angular.module('classy').constant('scDeepDiff', DeepDiff.diff);
})();